var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57617 7L2.34484 12.7862C2.02108 13.0869 1.51489 13.0681 1.21425 12.7444C0.913608 12.4206 0.932355 11.9144 1.25612 11.6138L6.22479 7L1.25612 2.38624C0.932355 2.0856 0.913608 1.57941 1.21425 1.25564C1.51489 0.931874 2.02108 0.913126 2.34484 1.21377L8.57617 7Z",
    fill: "#28AF06",
    stroke: "#28AF06",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightGreen);
export default __webpack_public_path__ + "static/media/chevron-right-green.60c132f86a240035d5c4efc37d98541e.svg";
export { ForwardRef as ReactComponent };